module.exports = __webpack_public_path__ + "img/banner1_11.f0374027.png";